import { ref } from 'vue';
import { defineStore } from 'pinia';
import { v4 as uuid } from 'uuid';
import Device, { ValueOf, KnownPlatformsKeys, KnownBrowsersKeys } from '@/interfaces/Device';

interface State {
  deviceID : string;
  deviceOS : ValueOf<KnownPlatformsKeys> | null;
  deviceBrowser : ValueOf<KnownBrowsersKeys> | null;
}

const useDeviceStore = defineStore({
  id: 'device',
  state: () => ref<State>({
    deviceID: '',
    deviceOS: '',
    deviceBrowser: '',
  }),
  getters: {
    getdeviceID(state) : string {
      return state.deviceID;
    },
    getdeviceOS(state) : ValueOf<KnownPlatformsKeys> | null {
      return state.deviceOS;
    },
    getdeviceBrowser(state) : ValueOf<KnownBrowsersKeys> | null {
      return state.deviceBrowser;
    },
  },
  actions: {
    initStore(device : Device) : void {
      if (this.deviceOS === '') {
        const os = device.os.name;
        this.deviceOS = os;
      }
      if (this.deviceBrowser === '') {
        this.deviceBrowser = device.browser.name;
      }
      if (this.deviceID === '') {
        this.deviceID = uuid();
      }
    },
  },
  persist: {
    enabled: true,
    strategies: [
      {
        key: 'device-details',
        storage: localStorage,
      },
    ],
  },
});

export default useDeviceStore;
